import styled from 'styled-components';

import { ResourceCardWrapper } from '../ResourceCard/styled';

export const ResourcesMyResourcesWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 24px;
`;

interface ResourcesMyResourcesContainerProps {
  hasDrafts?: boolean;
}

export const ResourcesMyResourcesContainer = styled.div<ResourcesMyResourcesContainerProps>`
  width: 100%;
  max-width: 1440px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 25px 40px 10px 40px;

  border-radius: 8px;
  background: rgba(255, 255, 255, 0.5);

  ${({ hasDrafts = false }) =>
    hasDrafts &&
    `
    ${ResourceCardWrapper} {
      opacity: 0.5 !important;
    }
  `}
`;

export const ResourcesMyResourcesTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const ResourcesMyResourcesTitle = styled.h2`
  font-weight: 400;
  font-size: 24px;
  line-height: normal;

  color: var(--color-text);
`;

export const ResourcesMyResourcesHeaderWrapper = styled.div`
  width: 100%;
  max-width: 1440px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

export const ResourcesMyResourcesCreateNewButton = styled.button`
  width: fit-content;
  height: 48px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  padding: 16px 48px;

  border-radius: 100px;
  border: none;
  background: var(--color-primary);
  cursor: pointer;

  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;

export const ResourcesMyResourcesCreateNewButtonText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;

  color: #ffffff;
`;
